import React from "react";
import { Badge, colors } from "../design/badge";
import { SideType } from "../models/SideType";

interface Props {
  side?: SideType;
}

const ParticipantSideBadge: React.FC<Props> = ({ side }) => {
  if (!side) return null;
  let color;
  let title;
  switch (side) {
    case "me":
      color = "red";
      title = "Mine";
      break;
    case "opponent":
      color = "blue";
      title = "Them";
      break;
    case "neutral":
      color = "zinc";
      title = "Neutral";
      break;
    default:
      color = "zinc";
      title = "Unknown";
      break;
  }
  return <Badge color={color as keyof typeof colors}>{title}</Badge>;
};

export default ParticipantSideBadge;
